import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useUserSettings } from '../modules/settings/useData';
import { clearUserDatePreferences, setUserDatePreferences } from '../utils/userDatePreferences';

/**
 * Keeps module-level date format in sync with the signed-in user's preferences
 * so formatDate / formatDateTime work outside React hooks.
 */
const UserDatePreferencesSync: React.FC = () => {
  const { user } = useAuth();
  const { userSettings } = useUserSettings();

  useEffect(() => {
    if (!user) {
      clearUserDatePreferences();
      return;
    }

    setUserDatePreferences({
      dateFormat: userSettings?.dateFormat ?? null,
      timeFormat: userSettings?.timeFormat ?? null,
    });
  }, [user, userSettings?.dateFormat, userSettings?.timeFormat]);

  return null;
};

export default UserDatePreferencesSync;
